import { Modal } from '@pmi/dsm-react';
import { useDeleteAdmin2FANumberMutation } from './apiSlice';
import styles from './deleteAdminPhoneNumber.module.scss';
import { toastWithAnalytics } from '../../../../../../shared/analytics';

interface DeleteAdminPhoneNumberProps {
  id: number;
  onCancel?: () => void;
  onSuccess?: () => void;
}

export default function DeleteAdmin2FANumberModal({
  id,
  onCancel = () => {},
  onSuccess = () => {},
}: DeleteAdminPhoneNumberProps) {
  const [deletePhoneNumber] = useDeleteAdmin2FANumberMutation();

  const onRemove = async () => {
    deletePhoneNumber({ id })
      .unwrap()
      .then(() => {
        toastWithAnalytics(
          'The phone number was removed successfully',
          'success',
        );
        onSuccess();
        onCancel();
      })
      .catch(() => {
        toastWithAnalytics(
          'There was an error removing the phone number',
          'danger',
        );
      });
  };
  const onCancelHandler = () => {
    onCancel();
  };

  return (
    <Modal
      show
      onClose={onCancelHandler}
      headline="Remove?"
      description=""
      customClassName={`${styles['remove-phone-number-modal']}`}
      headline_description="Are you sure you want to remove this phone number? This action cannot be undone."
      buttons={[
        {
          titleText: 'Cancel',
          variant: 'outline-secondary',
          onClick: onCancelHandler,
        },
        {
          titleText: 'Yes, Remove',
          variant: 'primary',
          onClick: onRemove,
        },
      ]}
    />
  );
}
